import { render, staticRenderFns } from "./Figure.vue?vue&type=template&id=32f986f5&scoped=true&"
import script from "./Figure.vue?vue&type=script&lang=js&"
export * from "./Figure.vue?vue&type=script&lang=js&"
import style0 from "./Figure.vue?vue&type=style&index=0&id=32f986f5&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f986f5",
  null
  
)

export default component.exports